module.exports = __webpack_public_path__ + "img/square-up.eda0d2df.svg";